import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

import { BudgetDetailModalComponent } from '../../budget/budget-detail-modal/budget-detail-modal.component';
import { FetchResourceBudgetsApproaching100Percent } from '../../budget/budget.actions';
import { BudgetState } from '../../budget/budget.state';
import BudgetUtilization from '../../models/BudgetUtilization';

@Component({
    selector: 'app-dashboard-budgets-widget',
    templateUrl: './dashboard-budgets-widget.component.html',
    styleUrls: ['./dashboard-budgets-widget.component.scss'],
})
export class DashboardBudgetsWidgetComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(BudgetState.ResourceBudgetsApproaching100Percent)
    rows$: Observable<BudgetUtilization[]>;
    rows: BudgetUtilization[] = null;

    displayedColumns: string[] = ['employee', 'budget', 'usage', 'over'];
    dataSource: MatTableDataSource<BudgetUtilization> = new MatTableDataSource<BudgetUtilization>();

    constructor(private router: Router, private store: Store, private modalService: NgbModal) {}

    ngOnInit(): void {
        this.store.dispatch(new FetchResourceBudgetsApproaching100Percent());
        this.subscriptions.add(
            this.rows$.subscribe((rows) => {
                this.rows = rows;
                this.dataSource.data = rows || [];
            }),
        );
    }

    goToBudgets() {
        this.router.navigate(['/', 'budget', 'overview']);
    }

    openBudget(row: BudgetUtilization): void {
        if (!row?.budget?.uuid) {
            return;
        }

        const modalRef = this.modalService.open(BudgetDetailModalComponent, {
            windowClass: 'modal-pane',
            animation: false,
        });
        modalRef.componentInstance.budgetId = row.budget.uuid;
    }

    usageClass(util: number): string {
        if (util >= 100) return 'usage-pill usage-pill--red';
        if (util >= 90) return 'usage-pill usage-pill--orange';
        return 'usage-pill usage-pill--yellow';
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
